// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3ayPd","itemTitle":"ClientEmergencyInfo_itemTitle__3QXrM","itemText":"ClientEmergencyInfo_itemText__Fhldt"};